export default {
  props: ['title', 'desc']
};